"use strict"

import React, { forwardRef } from "react"

import SeriesKey from "../../plotting/SeriesPlot/SeriesKey"
import { exportCSVFromArray } from "../../data_export/ObservationExporter"
import { exportObservationsObject } from "../../../../components/graphing/data_export/ObservationExporter"
import { ObsVsObsPlotBaton } from "./ObsVsObsPlotBaton"
import { ObsVsObsEditor } from "../../plotting/SeriesPlot/SeriesKey/ObsVsObsEditor"
import SeriesPlot from "../../plotting/SeriesPlot"
import { getCommentDataForRows, getObservationPlotData } from "../ObservationPlotFactory"
import { getSeriesConfigs } from "./utils"

export const ObsVsObsPlotFactory = (config) => ({
  Component: forwardRef((props, ref) => <SeriesPlot ref={ref} {...props} />),

  Key: (props) => {
    return (
      <>
        {!props.download && <ObsVsObsEditor {...props} />}
        {config.observations && config.observations.length > 0 && (
          <SeriesKey
            {...props}
            series={props.seriesConfigs}
            download={props.download}
            liveView={props.liveView}
          />
        )}
      </>
    )
  },

  makePlotBaton: () => {
    return new ObsVsObsPlotBaton(config)
  },

  getCrossPlotProps: (plotPropsArray = []) => {
    return {
      ...getSeriesConfigs(config.observations || []),
      observationTypesArray: plotPropsArray.map((plotProps) => plotProps.observationTypes || {}),
      queryTags: plotPropsArray[0] && plotPropsArray[0].queryTags,
    }
  },

  ensureDataRequested: (run, force_reload = false, is_first_run = false) =>
    getObservationPlotData(config, "observations", run, force_reload, is_first_run),

  getExportCSVName: (exportBaseName) => {
    return `${exportBaseName}_${(config.title || "unknown").replace(/[\s:]/g, "_")}.csv`
  },

  getCommentDataForRows: getCommentDataForRows,

  getDataForRows: (run, timeExtractor, minTime, maxTime, viewerState, zoomRanges, tzString, intl = null) => {
    return exportObservationsObject(
      timeExtractor,
      minTime,
      maxTime,
      run,
      config.observations,
      intl,
      config,
      tzString,
    )
  },

  makeExportCSV: (data) => exportCSVFromArray(data),
})

export default ObsVsObsPlotFactory
